import React from 'react';
import { faFileContract } from '@fortawesome/pro-regular-svg-icons';
import SIcon from './SIcon';

const Contract = props => <SIcon {...props} icon={faFileContract} fa />;

export default Contract;
